import script from "./DragModules.vue?vue&type=script&setup=true&lang=js"
export * from "./DragModules.vue?vue&type=script&setup=true&lang=js"

import "./DragModules.vue?vue&type=style&index=0&id=55496703&lang=css"

const __exports__ = script;

export default __exports__